import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import { SearchInputProps } from './interfaces';
import styles from './SearchInput.module.scss';
import SearchIcon from "../../SearchIcon/SearchIcon";


const SearchInput: FunctionComponent<SearchInputProps> = ({ value, onChange, placeholder, className }) => {
  const handleChange = ({ target }) => onChange(target.value)

  return (
    <label className={classNames(styles.searchContainer, className)}>
      <SearchIcon width={16} height={16} />
      <input
        className={styles.searchInput}
        type='text'
        placeholder={placeholder}
        onChange={handleChange}
        value={value}
      />
    </label>
  );
};

export default SearchInput;
